



















































































import { Component, Vue, Watch } from "vue-property-decorator";
import { tiposNaturezaServicosList, TipoNaturezaServico } from "@/models/commons/TipoNaturezaServico";
import ContabilContaPagarService from "@/service/ContabilContaPagarService";
import { RelatorioContaPagarModel } from "@/models/contabil/contas-pagar/RelatorioContaPagarModel" ;
import { ValidationObserver, ValidationProvider } from "vee-validate";
import MessageDialog from "@/components/modal/MessageDialog.vue";

@Component({
  components: {
    ValidationObserver,
    ValidationProvider,
    MessageDialog
  }
})
export default class ContaPagar extends Vue {

     $refs!: {
        relatorioObserver: InstanceType<typeof ValidationObserver>;
    };

    loading:boolean = false;

    openDialog = false;
    dialogTitle = "";
    dialogMessage = "";
    dialogStyle = "";
    dialogType = "";
    dialogKey = 0;

    relatorio: RelatorioContaPagarModel  =  {
        inicio: undefined,
        fim: undefined,
        naturezaServico: { valor: undefined, descricao: "Todas" },
    }

    tiposNaturezaServico = [
        { valor: undefined, descricao: "Todas" },
        { valor: "ASSISTENCIA_24H", descricao: "Assistência 24h" },
        { valor: "ORCAMENTO_AUTOMOTIVO", descricao: "Orçamento Automotivo Online" },
        { valor: "SERVICOS_SAUDE", descricao: "Serviços de Saúde" }
    ];

    gerarRelatorio() {
        this.$refs.relatorioObserver.validate().then((valid: boolean) => {
            
            if(valid) {
                this.loading = true;
                ContabilContaPagarService.gerarRelatorio(this.relatorio).then(res => {

                let fileURL = window.URL.createObjectURL(new Blob([res.data]));

                let fileLink = document.createElement('a');

                fileLink.href = fileURL;

                fileLink.setAttribute('download', 'relatorio_conta_pagar.pdf');

                document.body.appendChild(fileLink);

                fileLink.click();

                this.loading = false;

                }).catch(err => {

                    this.dialogTitle = "Ocorreu um erro ao gerar o relatório";
                    this.dialogMessage = err.message;
                    this.dialogStyle = "error";
                    this.openDialog = true;
                    this.loading = false;

                });

                this.limparformulario();
            }
            
        });    
    }

    gerarRelatorioExcel() {
        this.$refs.relatorioObserver.validate().then((valid: boolean) => {
            
            if(valid) {
                this.loading = true;
                ContabilContaPagarService.gerarRelatorioExcel(this.relatorio).then(res => {

                let fileURL = window.URL.createObjectURL(new Blob([res.data]));

                let fileLink = document.createElement('a');

                fileLink.href = fileURL;

                fileLink.setAttribute('download', 'relatorio_conta_pagar.xls');

                document.body.appendChild(fileLink);

                fileLink.click();

                this.loading = false;

                }).catch(err => {

                    this.dialogTitle = "Ocorreu um erro ao gerar o relatório";
                    this.dialogMessage = err.message;
                    this.dialogStyle = "error";
                    this.openDialog = true;
                    this.loading = false;

                });

                this.limparformulario();
            }
            
        });    
    }

    limparformulario() {
        this.relatorio = {
            inicio: undefined,
            fim: undefined,
            naturezaServico: undefined,
        }
        this.$refs.relatorioObserver.reset();
    }

    acaoDialog() {
        this.openDialog = false
    }

}
